import React, { useEffect, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import api, { fmtNum, fmtINR } from '@/lib/api';
import { Loading, EmptyState, StatusBadge, PriorityBadge } from '@/components/Shared';
import { Truck, MapPin, Package, Fuel, CalendarClock } from 'lucide-react';

export default function DriverToday() {
  const nav = useNavigate();
  const [orders, setOrders] = useState(null);
  const [stats, setStats] = useState(null);
  const load = useCallback(() => {
    api.get('/driver/deliveries').then((r) => setOrders(r.data));
    api.get('/driver/stats').then((r) => setStats(r.data));
  }, []);
  useEffect(() => { load(); }, [load]);
  if (!orders || !stats) return <Loading />;
  const active = orders.filter((o) => !['completed', 'invoice_generated', 'cancelled'].includes(o.status));
  return (
    <div className="space-y-4">
      <div className="grid grid-cols-3 gap-2">
        <Chip label="Today" value={stats.today_total} />
        <Chip label="Pending" value={stats.today_pending} />
        <Chip label="Litres" value={fmtNum(stats.total_litres_delivered)} />
      </div>
      <h2 className="font-display text-lg font-semibold">Active Deliveries</h2>
      {active.length === 0 ? <EmptyState title="No active deliveries" desc="New jobs will appear here when assigned." icon={Truck} /> : (
        <div className="space-y-2">
          {active.map((o) => (
            <div key={o.id} className="rounded-xl border border-border bg-card p-4 cursor-pointer hover:shadow-md" onClick={() => nav(`/driver/job/${o.id}`)} data-testid={`driver-job-${o.order_no}`}>
              <div className="flex items-center justify-between gap-2"><p className="font-medium">{o.order_no}</p><div className="flex items-center gap-1.5"><PriorityBadge priority={o.priority} /><StatusBadge status={o.status} label={o.status_label} /></div></div>
              <p className="text-sm mt-1">{o.customer_name}</p>
              <div className="flex items-center gap-2 text-xs text-muted-foreground mt-1"><Fuel className="h-3.5 w-3.5" />{fmtNum(o.pricing.qty)} {o.pricing.unit} · {o.pricing.product_name}</div>
              <div className="flex items-start gap-1 text-xs text-muted-foreground mt-1"><MapPin className="h-3.5 w-3.5 mt-0.5" />{o.address_text}</div>
              <div className="flex items-center gap-1 text-xs text-muted-foreground mt-1"><CalendarClock className="h-3.5 w-3.5" />{o.schedule_type === 'scheduled' ? (o.delivery_time || 'Scheduled') : 'ASAP (Deliver Now)'}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
const Chip = ({ label, value }) => <div className="rounded-xl border border-border bg-card p-3 text-center"><p className="text-xs text-muted-foreground">{label}</p><p className="font-display text-xl font-semibold">{value}</p></div>;
